import { HOST_BRANDING, type HostAppId } from './hosts';

/** Título, meta y theme-color según subdominio (antes del paint de React). */
export function applyHostDocumentBranding(appId: HostAppId): void {
  if (typeof document === 'undefined') return;

  const brand = HOST_BRANDING[appId];
  document.title = brand.title;

  const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', brand.description);
  setMeta('application-name', brand.title);
  setMeta('theme-color', brand.themeColor);

  document.documentElement.dataset.elynthisApp = appId;
}
